import { Injectable } from '@angular/core'
import { ModalOptions } from '@ionic/angular'
import { Translation } from './translation.service'
import { ModalComponent, ModalStyle } from '@doka-shared/common'

@Injectable({
  providedIn: 'root',
})
export class ErrorPopupService {
  constructor(private readonly translate: Translation) {}

  public getErrorModal(message: string, onRetry?: boolean): ModalOptions {
    let primaryButton = undefined
    if (onRetry) primaryButton = this.translate.translate('GENERAL.RETRY')
    const modalOpts: ModalOptions = {
      component: ModalComponent,
      cssClass: 'small-modal',
      componentProps: {
        title: this.translate.translate('GENERAL.ERROR'),
        text: message,
        cancelButtonLabel: this.translate.translate('GENERAL.CANCEL'),
        primaryButton,
        modalStyle: ModalStyle.Alert,
      },
    }
    return modalOpts
  }

  getPlannerErrorModal(errors: string[]): ModalOptions {
    let message = ''
    if (errors.length === 1) {
      message = errors[0]
    } else {
      message = '<ul>'
      errors.forEach((error) => (message += '<li>' + error + '</li>'))
      message += '</ul>'
    }

    const modalOpts: ModalOptions = {
      component: ModalComponent,
      cssClass: 'small-modal',
      componentProps: {
        title: this.translate.translate('GENERAL.ERROR'),
        text: message,
        criticalActionButtonLabel: this.translate.translate('GENERAL.OK'),
        modalStyle: ModalStyle.Alert,
      },
    }
    return modalOpts
  }
}
